/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { MARITAL_STATUS, CELLPHONE_DETAILS, PORTABLE_POSSESSIONS_CLAIM_HISTORY } from '../../../routes/routes';
import './Bling.css';
import { ProgressBar, Card } from 'react-bootstrap';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { addCarToQuote, postRegularDriverFlow, setIsOnQuoteScreen, setRegularDriver, setRegularPhoneNumber } from '../../../actions/salesActions';
import Covers from './Covers';


class CoverOptions extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            submitted: false,
            loggedIn: this.props.auth.uid ? true : false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

    componentDidMount() {
        this.props.dispatchSetIsOnQuoteScreen(true, "blingcovers", "Bling " + " item");
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        if (name === "") {

        }
    }

    handleClick() {
    }

    async handleBack(e: any) {
        await this.props.dispatchSetIsOnQuoteScreen(false, "", "");
        this.props.dispatchRedirectTo(PORTABLE_POSSESSIONS_CLAIM_HISTORY)
    }

    handleRedirect(nextPage: string) {
        this.props.dispatchRedirectTo(nextPage);
    }

    public render() {
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={45} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid mt-32px mobile-mt-20px mobile-nopa">
                        <div className="row justify-content-center noma">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col-lg-12 nopa text-center">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-bling-cover-options-main-contentholder mt-21px mobile-mt-17px mb-28px text-center ssp-addreplacement-value-p-holder">
                                            <div className="mb-0px font-size-16px font-weight-500 ssp-addreplacement-value-intro-header">
                                                Choose cover for your<br />
                                                <b>{this.props.sales.portablePossessionDescription}</b>
                                            </div>
                                        </div>
                                        <Covers />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetRegularPhonenumber: (regularPhoneNumber: any) => dispatch(setRegularPhoneNumber(regularPhoneNumber)),
        dispatchSetIsOnQuoteScreen: (flag, itemId, itemDescription) => dispatch(setIsOnQuoteScreen(flag, itemId, itemDescription)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CoverOptions);